module.exports = __webpack_public_path__ + "img/active-directories.f464b150.png";